export const NewPartner = {
  labelName: 'Nome',
  labelSurname: 'Apelido',
  labelPerfil: 'Perfil',
  labelPartner: 'Parceiro',
  labelEmail: 'Email',
  labelStores: 'Lojas',
  profilePlaceholder: 'Escolha o perfil',
  partnerPlaceholder: 'Escolha o parceiro',
  storePlaceholder: 'Escolha a loja',
  ALL: 'Todos',
  ROLE_ADMIN: 'Administrador',
  ROLE_PARTNER_ADMIN: 'Administrador - Parceiro',
  ROLE_MOTORISTA: 'Motorista',
  ROLE_RECOLHA: 'Recolhas',
  ROLE_DEDICATED_CAR: 'Administrador - Carro Dedicado'
}



// WEBPACK FOOTER //
// ./src/translations/pt/miscellaneous/NewPartner.js